const alignValues = ['left', 'center', 'right'];
const alignProp = {
    type: 'enum',
    values: alignValues,
    default: undefined,
    responsive: true,
};
export { alignProp };
//# sourceMappingURL=text-align.prop.js.map